import React, { useState, useRef, useEffect } from "react";
import "./Security.scss";

// ─── Icons ────────────────────────────────────────────────────────────────────
const Ico = {
  Shield: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
  Lock: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  ),
  Key: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" />
    </svg>
  ),
  Mobile: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
      <line x1="12" y1="18" x2="12.01" y2="18" />
    </svg>
  ),
  Globe: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="2" y1="12" x2="22" y2="12" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  ),
  Clock: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  AlertTri: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  Check: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
  Edit: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
    </svg>
  ),
  Plus: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  ),
  Trash: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
      <path d="M10 11v6" />
      <path d="M14 11v6" />
      <path d="M9 6V4h6v2" />
    </svg>
  ),
  Eye: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  Save: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
      <polyline points="17 21 17 13 7 13 7 21" />
      <polyline points="7 3 7 8 15 8" />
    </svg>
  ),
  Audit: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <polyline points="10 9 9 9 8 9" />
    </svg>
  ),
  Close: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
};

// ─── Toggle Switch ────────────────────────────────────────────────────────────
function Toggle({ checked, onChange, disabled }) {
  return (
    <label className={`sec-toggle${disabled ? " sec-toggle--disabled" : ""}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => !disabled && onChange(e.target.checked)}
        disabled={disabled}
      />
      <span />
    </label>
  );
}

// ─── Impact Warning Banner ────────────────────────────────────────────────────
function ImpactBanner({ message, onDismiss }) {
  return (
    <div className="sec-banner sec-banner--warn">
      <span className="sec-banner__icon">{Ico.AlertTri}</span>
      <span className="sec-banner__msg">{message}</span>
      {onDismiss && (
        <button className="sec-banner__close" onClick={onDismiss}>
          {Ico.Close}
        </button>
      )}
    </div>
  );
}

// ─── Section Card ─────────────────────────────────────────────────────────────
function SectionCard({
  icon,
  title,
  subtitle,
  children,
  onSave,
  saveLabel = "Save Changes",
  saving,
}) {
  return (
    <div className="sec-section-card">
      <div className="sec-section-card__header">
        <div className="sec-section-card__icon">{icon}</div>
        <div>
          <div className="sec-section-card__title">{title}</div>
          {subtitle && <div className="sec-section-card__sub">{subtitle}</div>}
        </div>
      </div>
      <div className="sec-section-card__body">{children}</div>
      {onSave && (
        <div className="sec-section-card__footer">
          <button
            className="sec-btn sec-btn--primary"
            onClick={onSave}
            disabled={saving}
          >
            {saving ? (
              "Saving…"
            ) : (
              <>
                {Ico.Save} {saveLabel}
              </>
            )}
          </button>
        </div>
      )}
    </div>
  );
}

// ─── Field Row ────────────────────────────────────────────────────────────────
function FieldRow({ label, hint, children }) {
  return (
    <div className="sec-field-row">
      <div className="sec-field-row__label">
        <span>{label}</span>
        {hint && <span className="sec-field-row__hint">{hint}</span>}
      </div>
      <div className="sec-field-row__control">{children}</div>
    </div>
  );
}

// ─── Audit Log Row ────────────────────────────────────────────────────────────
const AUDIT_LOGS = [
  {
    id: 1,
    admin: "Admin",
    action: "Changed Password Expiry → 90 days",
    time: "Today 11:42",
    severity: "medium",
  },
  {
    id: 2,
    admin: "Admin",
    action: "Enabled MFA requirement for all admins",
    time: "Today 10:17",
    severity: "high",
  },
  {
    id: 3,
    admin: "Ahmed Al Balushi",
    action: "Added IP 10.0.0.0/8 to allowlist",
    time: "Yesterday 15:30",
    severity: "high",
  },
  {
    id: 4,
    admin: "Admin",
    action: "Updated Session Timeout → 30 min",
    time: "Jun 10, 14:22",
    severity: "medium",
  },
  {
    id: 5,
    admin: "Admin",
    action: "Device limit updated → 3 per user",
    time: "Jun 8, 09:05",
    severity: "low",
  },
];

// ─── IP Allowlist ─────────────────────────────────────────────────────────────
function IpAllowlist() {
  const [enabled, setEnabled] = useState(false);
  const [entries, setEntries] = useState(["10.0.0.0/8", "192.168.1.0/24"]);
  const [newIp, setNewIp] = useState("");
  const [warning, setWarning] = useState(false);
  const [error, setError] = useState("");

  const handleToggle = (v) => {
    if (v) setWarning(true);
    else setEnabled(false);
  };

  const handleAdd = () => {
    if (!newIp.trim()) return;
    const ipRegex = /^(\d{1,3}\.){3}\d{1,3}(\/\d{1,2})?$/;
    if (!ipRegex.test(newIp.trim())) {
      setError("Enter a valid IP or CIDR range (e.g. 192.168.1.0/24)");
      return;
    }
    if (entries.includes(newIp.trim())) {
      setError("IP already in list");
      return;
    }
    setEntries((p) => [...p, newIp.trim()]);
    setNewIp("");
    setError("");
  };

  return (
    <div className="sec-ip-block">
      <div className="sec-ip-block__toggle-row">
        <div>
          <div className="sec-ip-block__toggle-label">Enable IP Allowlist</div>
          <div className="sec-ip-block__toggle-sub">
            Restrict admin portal access to listed IPs only. Test thoroughly
            before enforcing.
          </div>
        </div>
        <Toggle checked={enabled} onChange={handleToggle} />
      </div>

      {warning && (
        <ImpactBanner
          message="Warning: Enabling IP allowlist may lock out admins not on the listed IPs. Ensure your current IP is included before saving."
          onDismiss={() => {
            setWarning(false);
            setEnabled(true);
          }}
        />
      )}

      <div className={`sec-ip-list${!enabled ? " sec-ip-list--disabled" : ""}`}>
        {entries.map((ip, i) => (
          <div key={i} className="sec-ip-tag">
            <span>{ip}</span>
            <button
              className="sec-ip-tag__remove"
              onClick={() =>
                enabled && setEntries((p) => p.filter((_, j) => j !== i))
              }
              disabled={!enabled}
            >
              {Ico.Trash}
            </button>
          </div>
        ))}
        <div className="sec-ip-add">
          <input
            className={`sec-input${error ? " sec-input--error" : ""}`}
            placeholder="e.g. 10.0.0.0/8"
            value={newIp}
            disabled={!enabled}
            onChange={(e) => {
              setNewIp(e.target.value);
              setError("");
            }}
            onKeyDown={(e) => e.key === "Enter" && handleAdd()}
          />
          <button
            className="sec-btn sec-btn--secondary"
            onClick={handleAdd}
            disabled={!enabled}
          >
            {Ico.Plus} Add
          </button>
        </div>
        {error && <span className="sec-field-error">{error}</span>}
      </div>
    </div>
  );
}

// ─── Main Component ───────────────────────────────────────────────────────────
const Security = () => {
  // ── Password Policy ─────────────────────────────────────────────────────────
  const [pwPolicy, setPwPolicy] = useState({
    minLength: 10,
    requireUpper: true,
    requireNumber: true,
    requireSymbol: true,
    expiryDays: 90,
    preventReuse: 5,
    lockAttempts: 5,
    lockDuration: 15,
  });
  const [pwSaving, setPwSaving] = useState(false);
  const [pwSaved, setPwSaved] = useState(false);

  // ── MFA ─────────────────────────────────────────────────────────────────────
  const [mfaEnabled, setMfaEnabled] = useState(false);
  const [mfaRequired, setMfaRequired] = useState(false);
  const [mfaBanner, setMfaBanner] = useState(false);
  const [mfaSaving, setMfaSaving] = useState(false);

  // ── Sessions ─────────────────────────────────────────────────────────────────
  const [sessions, setSessions] = useState({
    webTimeoutMin: 30,
    mobileTimeoutDays: 7,
    deviceLimit: 3,
    singleSessionAdmin: false,
  });
  const [sessSaving, setSessSaving] = useState(false);
  const [sessSaved, setSessSaved] = useState(false);

  // ── Audit Log ────────────────────────────────────────────────────────────────
  const [showAudit, setShowAudit] = useState(false);

  const save = (set, setSaving, setSaved) => {
    setSaving(true);
    setTimeout(() => {
      setSaving(false);
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    }, 1000);
  };

  const setPw = (k, v) => setPwPolicy((p) => ({ ...p, [k]: v }));
  const setSes = (k, v) => setSessions((p) => ({ ...p, [k]: v }));

  // ── Tab state ─────────────────────────────────────────────────────────────
  const TABS = [
    "Password Policy",
    "MFA",
    "Sessions & Devices",
    "IP Allowlist",
    "Audit Trail",
  ];
  const [tab, setTab] = useState(0);

  return (
    <div className="sec-page">
      {/* ── Page Header ── */}
      <div className="sec-header">
        <div className="sec-header__left">
          <span className="sec-header__label">Admin Portal</span>
          <h1 className="sec-header__title">Security Settings</h1>
          <p className="sec-header__subtitle">
            Configure portal and mobile security policies. All changes are
            audited.
          </p>
        </div>
        <button
          className="sec-btn sec-btn--secondary"
          onClick={() => setShowAudit(true)}
        >
          {Ico.Audit} View Audit Trail
        </button>
      </div>

      {/* ── KPI Bar ── */}
      <div className="sec-kpi-grid">
        {[
          {
            label: "Password Policy",
            value: "Active",
            color: "#22C55E",
            bg: "rgba(34,197,94,0.10)",
            icon: Ico.Lock,
          },
          {
            label: "MFA",
            value: mfaEnabled ? "Enabled" : "Optional",
            color: mfaEnabled ? "#22C55E" : "#F59E0B",
            bg: mfaEnabled ? "rgba(34,197,94,0.10)" : "rgba(245,158,11,0.10)",
            icon: Ico.Key,
          },
          {
            label: "Session Timeout",
            value: `${sessions.webTimeoutMin} min`,
            color: "#0062FE",
            bg: "rgba(0,98,254,0.10)",
            icon: Ico.Clock,
          },
          {
            label: "IP Allowlist",
            value: "Disabled",
            color: "#9CA3AF",
            bg: "#F3F4F6",
            icon: Ico.Globe,
          },
          {
            label: "Device Limit",
            value: `${sessions.deviceLimit} / user`,
            color: "#8B5CF6",
            bg: "rgba(139,92,246,0.10)",
            icon: Ico.Mobile,
          },
        ].map((k) => (
          <div key={k.label} className="sec-kpi">
            <div
              className="sec-kpi__icon"
              style={{ background: k.bg, color: k.color }}
            >
              {k.icon}
            </div>
            <div className="sec-kpi__body">
              <div className="sec-kpi__value" style={{ color: k.color }}>
                {k.value}
              </div>
              <div className="sec-kpi__label">{k.label}</div>
            </div>
          </div>
        ))}
      </div>

      {/* ── Tabs ── */}
      <div className="sec-tabs-wrap">
        <div className="sec-tabs">
          {TABS.map((t, i) => (
            <button
              key={t}
              className={`sec-tab${tab === i ? " active" : ""}`}
              onClick={() => setTab(i)}
            >
              {t}
            </button>
          ))}
        </div>
      </div>

      <div className="sec-content">
        {/* ── Password Policy ── */}
        {tab === 0 && (
          <SectionCard
            icon={
              <div className="sec-section-icon sec-section-icon--blue">
                {Ico.Lock}
              </div>
            }
            title="Password Policy"
            subtitle="Applied to all local database users and admin accounts."
            onSave={() => save(setPwPolicy, setPwSaving, setPwSaved)}
            saveLabel={pwSaved ? "✓ Saved" : "Save Policy"}
            saving={pwSaving}
          >
            <FieldRow
              label="Minimum Length"
              hint="Applies to all new passwords"
            >
              <div className="sec-number-input">
                <button
                  onClick={() =>
                    setPw("minLength", Math.max(8, pwPolicy.minLength - 1))
                  }
                >
                  −
                </button>
                <input
                  type="number"
                  className="sec-input sec-input--sm"
                  value={pwPolicy.minLength}
                  onChange={(e) =>
                    setPw("minLength", Math.max(8, Number(e.target.value)))
                  }
                  min={8}
                  max={32}
                />
                <button
                  onClick={() =>
                    setPw("minLength", Math.min(32, pwPolicy.minLength + 1))
                  }
                >
                  +
                </button>
                <span className="sec-unit">characters</span>
              </div>
            </FieldRow>

            <FieldRow
              label="Complexity Requirements"
              hint="Select all that apply"
            >
              <div className="sec-check-group">
                {[
                  { key: "requireUpper", label: "Uppercase letter (A–Z)" },
                  { key: "requireNumber", label: "Numeric digit (0–9)" },
                  { key: "requireSymbol", label: "Special character (!@#…)" },
                ].map(({ key, label }) => (
                  <label key={key} className="sec-check-row">
                    <input
                      type="checkbox"
                      checked={pwPolicy[key]}
                      onChange={(e) => setPw(key, e.target.checked)}
                    />
                    <span>{label}</span>
                  </label>
                ))}
              </div>
            </FieldRow>

            <FieldRow label="Password Expiry" hint="0 = never expire">
              <div className="sec-number-input">
                <button
                  onClick={() =>
                    setPw("expiryDays", Math.max(0, pwPolicy.expiryDays - 15))
                  }
                >
                  −
                </button>
                <input
                  type="number"
                  className="sec-input sec-input--sm"
                  value={pwPolicy.expiryDays}
                  onChange={(e) =>
                    setPw("expiryDays", Math.max(0, Number(e.target.value)))
                  }
                  min={0}
                  max={365}
                />
                <button
                  onClick={() =>
                    setPw("expiryDays", Math.min(365, pwPolicy.expiryDays + 15))
                  }
                >
                  +
                </button>
                <span className="sec-unit">days</span>
              </div>
            </FieldRow>

            <FieldRow label="Prevent Reuse" hint="Last N passwords blocked">
              <div className="sec-number-input">
                <button
                  onClick={() =>
                    setPw(
                      "preventReuse",
                      Math.max(0, pwPolicy.preventReuse - 1),
                    )
                  }
                >
                  −
                </button>
                <input
                  type="number"
                  className="sec-input sec-input--sm"
                  value={pwPolicy.preventReuse}
                  onChange={(e) =>
                    setPw("preventReuse", Math.max(0, Number(e.target.value)))
                  }
                  min={0}
                  max={20}
                />
                <button
                  onClick={() =>
                    setPw(
                      "preventReuse",
                      Math.min(20, pwPolicy.preventReuse + 1),
                    )
                  }
                >
                  +
                </button>
                <span className="sec-unit">passwords</span>
              </div>
            </FieldRow>

            <div className="sec-divider" />

            <FieldRow
              label="Failed Login Lock"
              hint="Account temporarily locked after N failed attempts"
            >
              <div className="sec-inline-pair">
                <div className="sec-number-input">
                  <button
                    onClick={() =>
                      setPw(
                        "lockAttempts",
                        Math.max(3, pwPolicy.lockAttempts - 1),
                      )
                    }
                  >
                    −
                  </button>
                  <input
                    type="number"
                    className="sec-input sec-input--sm"
                    value={pwPolicy.lockAttempts}
                    onChange={(e) =>
                      setPw("lockAttempts", Math.max(3, Number(e.target.value)))
                    }
                    min={3}
                    max={20}
                  />
                  <button
                    onClick={() =>
                      setPw(
                        "lockAttempts",
                        Math.min(20, pwPolicy.lockAttempts + 1),
                      )
                    }
                  >
                    +
                  </button>
                  <span className="sec-unit">attempts</span>
                </div>
                <span className="sec-unit" style={{ color: "#6B7280" }}>
                  lock for
                </span>
                <div className="sec-number-input">
                  <button
                    onClick={() =>
                      setPw(
                        "lockDuration",
                        Math.max(5, pwPolicy.lockDuration - 5),
                      )
                    }
                  >
                    −
                  </button>
                  <input
                    type="number"
                    className="sec-input sec-input--sm"
                    value={pwPolicy.lockDuration}
                    onChange={(e) =>
                      setPw("lockDuration", Math.max(5, Number(e.target.value)))
                    }
                    min={5}
                    max={60}
                  />
                  <button
                    onClick={() =>
                      setPw(
                        "lockDuration",
                        Math.min(60, pwPolicy.lockDuration + 5),
                      )
                    }
                  >
                    +
                  </button>
                  <span className="sec-unit">min</span>
                </div>
              </div>
            </FieldRow>

            <div className="sec-policy-summary">
              <div className="sec-policy-summary__title">
                Current policy summary
              </div>
              <ul>
                <li>
                  Min {pwPolicy.minLength} chars
                  {pwPolicy.requireUpper ? ", uppercase" : ""}
                  {pwPolicy.requireNumber ? ", number" : ""}
                  {pwPolicy.requireSymbol ? ", symbol" : ""}
                </li>
                <li>
                  Expires every{" "}
                  {pwPolicy.expiryDays > 0
                    ? `${pwPolicy.expiryDays} days`
                    : "never"}
                </li>
                <li>Prevents last {pwPolicy.preventReuse} passwords</li>
                <li>
                  Locks after {pwPolicy.lockAttempts} attempts for{" "}
                  {pwPolicy.lockDuration} min
                </li>
              </ul>
            </div>
          </SectionCard>
        )}

        {/* ── MFA ── */}
        {tab === 1 && (
          <SectionCard
            icon={
              <div className="sec-section-icon sec-section-icon--purple">
                {Ico.Key}
              </div>
            }
            title="Multi-Factor Authentication"
            subtitle="Controls MFA enforcement for admin portal users."
            onSave={() => save(null, setMfaSaving, () => {})}
            saveLabel="Save MFA Settings"
            saving={mfaSaving}
          >
            {mfaBanner && (
              <ImpactBanner
                message="Enabling MFA will require all admins to set up an authenticator app on their next login. Ensure all admins are notified beforehand."
                onDismiss={() => setMfaBanner(false)}
              />
            )}

            <FieldRow
              label="Enable MFA for Admins"
              hint="Phase 2 feature — TOTP / authenticator app"
            >
              <Toggle
                checked={mfaEnabled}
                onChange={(v) => {
                  setMfaEnabled(v);
                  if (v) setMfaBanner(true);
                }}
              />
            </FieldRow>

            <FieldRow
              label="Make MFA Mandatory"
              hint="Admins without MFA set up cannot log in"
            >
              <Toggle
                checked={mfaRequired}
                onChange={(v) => setMfaRequired(v)}
                disabled={!mfaEnabled}
              />
            </FieldRow>

            <FieldRow
              label="Grace Period"
              hint="Days allowed to set up MFA before enforcement"
            >
              <div className="sec-number-input">
                <button disabled={!mfaEnabled}>−</button>
                <input
                  type="number"
                  className="sec-input sec-input--sm"
                  defaultValue={7}
                  disabled={!mfaEnabled}
                  min={1}
                  max={30}
                />
                <button disabled={!mfaEnabled}>+</button>
                <span className="sec-unit">days</span>
              </div>
            </FieldRow>

            <div className="sec-divider" />

            <div className="sec-info-box">
              <div className="sec-info-box__title">
                Supported MFA Methods (Phase 2)
              </div>
              <div className="sec-info-box__list">
                {[
                  "TOTP (Google Authenticator, Authy)",
                  "SMS OTP (requires SMS gateway config)",
                  "Email OTP (requires email service config)",
                ].map((m) => (
                  <div key={m} className="sec-info-box__item">
                    <span className="sec-info-box__check">{Ico.Check}</span>
                    {m}
                  </div>
                ))}
              </div>
            </div>
          </SectionCard>
        )}

        {/* ── Sessions ── */}
        {tab === 2 && (
          <SectionCard
            icon={
              <div className="sec-section-icon sec-section-icon--blue">
                {Ico.Clock}
              </div>
            }
            title="Sessions & Devices"
            subtitle="Control session lifetime and concurrent device access."
            onSave={() => save(setSessions, setSessSaving, setSessSaved)}
            saveLabel={sessSaved ? "✓ Saved" : "Save Session Settings"}
            saving={sessSaving}
          >
            <ImpactBanner
              message="Changing session settings will not terminate existing active sessions. New policy applies on next login."
              onDismiss={null}
            />

            <FieldRow
              label="Web Session Timeout"
              hint="Admin portal inactivity timeout"
            >
              <div className="sec-number-input">
                <button
                  onClick={() =>
                    setSes(
                      "webTimeoutMin",
                      Math.max(5, sessions.webTimeoutMin - 5),
                    )
                  }
                >
                  −
                </button>
                <input
                  type="number"
                  className="sec-input sec-input--sm"
                  value={sessions.webTimeoutMin}
                  onChange={(e) =>
                    setSes("webTimeoutMin", Math.max(5, Number(e.target.value)))
                  }
                  min={5}
                  max={480}
                />
                <button
                  onClick={() =>
                    setSes(
                      "webTimeoutMin",
                      Math.min(480, sessions.webTimeoutMin + 5),
                    )
                  }
                >
                  +
                </button>
                <span className="sec-unit">minutes</span>
              </div>
            </FieldRow>

            <FieldRow
              label="Mobile Session Lifetime"
              hint="How long mobile users stay logged in"
            >
              <div className="sec-number-input">
                <button
                  onClick={() =>
                    setSes(
                      "mobileTimeoutDays",
                      Math.max(1, sessions.mobileTimeoutDays - 1),
                    )
                  }
                >
                  −
                </button>
                <input
                  type="number"
                  className="sec-input sec-input--sm"
                  value={sessions.mobileTimeoutDays}
                  onChange={(e) =>
                    setSes(
                      "mobileTimeoutDays",
                      Math.max(1, Number(e.target.value)),
                    )
                  }
                  min={1}
                  max={90}
                />
                <button
                  onClick={() =>
                    setSes(
                      "mobileTimeoutDays",
                      Math.min(90, sessions.mobileTimeoutDays + 1),
                    )
                  }
                >
                  +
                </button>
                <span className="sec-unit">days</span>
              </div>
            </FieldRow>

            <FieldRow
              label="Device Limit per User"
              hint="Max concurrent active devices"
            >
              <div className="sec-number-input">
                <button
                  onClick={() =>
                    setSes("deviceLimit", Math.max(1, sessions.deviceLimit - 1))
                  }
                >
                  −
                </button>
                <input
                  type="number"
                  className="sec-input sec-input--sm"
                  value={sessions.deviceLimit}
                  onChange={(e) =>
                    setSes("deviceLimit", Math.max(1, Number(e.target.value)))
                  }
                  min={1}
                  max={10}
                />
                <button
                  onClick={() =>
                    setSes(
                      "deviceLimit",
                      Math.min(10, sessions.deviceLimit + 1),
                    )
                  }
                >
                  +
                </button>
                <span className="sec-unit">devices</span>
              </div>
            </FieldRow>

            <FieldRow
              label="Single Session for Admins"
              hint="Force admins to one active session at a time"
            >
              <Toggle
                checked={sessions.singleSessionAdmin}
                onChange={(v) => setSes("singleSessionAdmin", v)}
              />
            </FieldRow>
          </SectionCard>
        )}

        {/* ── IP Allowlist ── */}
        {tab === 3 && (
          <SectionCard
            icon={
              <div className="sec-section-icon sec-section-icon--green">
                {Ico.Globe}
              </div>
            }
            title="IP Allowlist"
            subtitle="Restrict admin portal access to specific IP ranges. Test thoroughly before enabling."
          >
            <IpAllowlist />
          </SectionCard>
        )}

        {/* ── Audit Trail ── */}
        {tab === 4 && (
          <SectionCard
            icon={
              <div className="sec-section-icon sec-section-icon--navy">
                {Ico.Audit}
              </div>
            }
            title="Security Change Audit Trail"
            subtitle="Read-only log of all security policy changes. Every change is recorded."
          >
            <div className="sec-audit-table-wrap">
              <table className="sec-audit-table">
                <thead>
                  <tr>
                    <th>Action</th>
                    <th>Admin</th>
                    <th>Time</th>
                    <th>Severity</th>
                  </tr>
                </thead>
                <tbody>
                  {AUDIT_LOGS.map((log) => (
                    <tr key={log.id}>
                      <td>{log.action}</td>
                      <td>
                        <div className="sec-manager-cell">
                          <div className="sec-manager-cell__avatar">
                            {log.admin
                              .split(" ")
                              .slice(0, 2)
                              .map((w) => w[0])
                              .join("")
                              .toUpperCase()}
                          </div>
                          {log.admin}
                        </div>
                      </td>
                      <td
                        style={{
                          color: "#6B7280",
                          fontSize: 12.5,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {log.time}
                      </td>
                      <td>
                        <span
                          className={`sec-badge sec-badge--${log.severity}`}
                        >
                          {log.severity.charAt(0).toUpperCase() +
                            log.severity.slice(1)}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </SectionCard>
        )}
      </div>

      {/* ── Audit Slide-over ── */}
      {showAudit && (
        <>
          <div
            className="sec-drawer-overlay"
            onClick={() => setShowAudit(false)}
          />
          <div className="sec-drawer">
            <div className="sec-drawer__header">
              <div>
                <h3 className="sec-drawer__title">Security Audit Trail</h3>
                <p className="sec-drawer__subtitle">
                  All security policy changes — read-only
                </p>
              </div>
              <button
                className="sec-drawer__close"
                onClick={() => setShowAudit(false)}
              >
                {Ico.Close}
              </button>
            </div>
            <div className="sec-drawer__body">
              {AUDIT_LOGS.map((log) => (
                <div key={log.id} className="sec-audit-item">
                  <div
                    className={`sec-audit-item__dot sec-audit-item__dot--${log.severity}`}
                  />
                  <div className="sec-audit-item__content">
                    <div className="sec-audit-item__action">{log.action}</div>
                    <div className="sec-audit-item__meta">
                      {log.admin} · {log.time}
                    </div>
                  </div>
                  <span className={`sec-badge sec-badge--${log.severity}`}>
                    {log.severity.charAt(0).toUpperCase() +
                      log.severity.slice(1)}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Security;
